import React, { useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import HTMLFlipBook from "react-pageflip";

const NEWSLETTER_3_IMG = [
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_3_1.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_3_2.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_3_3.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_3_4.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_3_5.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_3_6.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_3_7.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_3_8.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_3_9.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_3_10.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_3_11.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_3_12.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_3_13.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_3_14.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_3_15.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_3_16.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_3_17.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_3_18.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_3_19.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_3_20.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_3_21.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_3_22.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_3_23.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_3_24.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_3_25.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_3_26.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_3_27.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_3_28.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_3_29.jpg",
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_3_30.jpg",
];

function Newsletter3() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const flipBookRef = useRef();
  const newsletter = state?.newsletter;
  const goToNextPage = () => {
    if (flipBookRef.current) {
      flipBookRef.current.pageFlip().flipNext(); // Call flipNext method
    }
  };

  const goToPreviousPage = () => {
    if (flipBookRef.current) {
      flipBookRef.current.pageFlip().flipPrev(); // Call flipPrev method
    }
  };
  if (!newsletter) {
    return (
      <div className="container mt-5">
        <p>
          No newsletter selected.{" "}
          <button onClick={() => navigate(-1)}>Go Back</button>
        </p>
      </div>
    );
  }
  return (
    <>
      <div className="container">
        {newsletter === "news1" && (
          <div className="row inner-content">
            <div className="col-md-12">
              <div className="flipOpen">
                <HTMLFlipBook
                  ref={flipBookRef}
                  width={600}
                  height={800}
                  minWidth={315}
                  maxWidth={1000}
                  minHeight={400}
                  mobileScrollSupport={true}
                  showCover={true}
                  useMouseEvents={true}
                  className="flipPageComponent"
                  pageBackground="rgb(255, 255, 255)"
                  uncutPages={true}
                >
                  {NEWSLETTER_3_IMG.map((img, index) => (
                    <div key={index}>
                      <img
                        src={img}
                        alt={`Page ${index + 1}`}
                      />
                    </div>
                  ))}
                </HTMLFlipBook>
              </div>
              <div className="navigation-buttons">
                <button onClick={goToPreviousPage} className="btn btn-primary">
                  <i class="bi bi-arrow-left"></i>
                </button>
                <button onClick={goToNextPage} className="btn btn-primary">
                  <i class="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Newsletter3;
